export default __webpack_public_path__ + "static/media/SignupPage.65adc9df.jpeg";